export class LoadIntoDocument {
    public static script(uri: string, callback: (error?: Error) => void): void {
        let scriptLoaded = false;
        const head = document.getElementsByTagName("head")[0] || document.documentElement;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const script: any = document.createElement("script");

        function loadHandler(): void {
            if (scriptLoaded) {
                return;
            }

            if (!script.readyState || script.readyState === "loaded" || script.readyState === "complete") {
                scriptLoaded = true;
                callback();
            }
        }

        // Hang the user callback to be called when the script completes to load.
        // NOTE(user): This callback will be called in IE even upon error. In any
        // case it is the client's responsibility to verify that the script ran
        // successfully.
        script.onload = loadHandler;
        script.onreadystatechange = loadHandler;

        // Add an error callback.
        // NOTE(user): Not supported in IE.
        script.onerror = () => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            callback(new Error("Error while loading script."));
        };

        // Add the script element to the document.
        // NOTE(user): Safari never loads the script if we don't set
        // the src attribute before appending.
        script.src = uri;
        head.appendChild(script);
    }

    public static styleSheet(uri: string, callback: (error?: Error) => void): void {
        const resolve = () => callback(undefined);
        const reject = () => callback(new Error("Error while loading stylesheet."));

        const head = document.getElementsByTagName("head")[0] || document.documentElement;
        const link = document.createElement("link");

        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.addEventListener("load", resolve);
        link.addEventListener("error", reject);
        head.appendChild(link);
        link.setAttribute("href", uri);
    }
}
